import { render, staticRenderFns } from "./allAudits.vue?vue&type=template&id=1197d77e&scoped=true"
import script from "./allAudits.vue?vue&type=script&lang=ts"
export * from "./allAudits.vue?vue&type=script&lang=ts"
import style0 from "./allAudits.vue?vue&type=style&index=0&id=1197d77e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1197d77e",
  null
  
)

export default component.exports